<template>
  <div class='header'>
    <img src="../../assets/icon/logo.png" alt="">
    <span class='center'> 通行证 </span>
    <span class='right' @click='goToLogin' v-if="!user.jrwyToken">
      已有账号，<span>马上登录</span>
    </span>
    <span class='right' @click='goToUser' v-else>
      <span>返回个人中心</span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    goToLogin () {
      this.$router.push({
        path: '/login'
      })
    },
    goToUser() {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style scoped lang='less'>
@import "../../assets/styles/common.less";
.header {
  background-color: #F4F4F4;
  line-height: 33 / @f;
  padding-bottom: 5 / @f;
  box-sizing: border-box;
  img {
    vertical-align: -9 / @f;
    width: 122 / @f;
  }
  .center {
    font-size: 19 / @f;
  }
  .right {
    float: right;
    font-size: 13 / @f;
    line-height: 33 / @f;
    span {
      color: @Mcolor;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 750px) {
  .header {
    font-size: 8 / @f;
    padding: 0 10 / @f;
    .right {
      line-height: 40/ @f;
    }
  }
}
</style>
